<template>
  <div>
    <iframe :src="orderDetails.payment_url" />
  </div>
</template>

<script>
export default {
  name: "Payment",

  computed: {
    orderDetails() {
      return this.$store.getters["cart/orderDetails"];
    }
  }
};
</script>
